const X_TITLE_RE = /(?:https?:\/\/(?:www\.)?(?:x|twitter)\.com\/|xhttpsxcom|httpsxcom|^X\s+@)/i
const STATUS_ID_RE = /(?:status\/|status)(\d{6,25})|#(\d{6})/i
const TODOIST_TASK_SUFFIX_RE = /__[A-Za-z0-9]{8,}$/

type TopicTitleInput = {
  title?: string | null
  source_kind?: string | null
}

function statusShort(title: string): string | null {
  const match = title.match(STATUS_ID_RE)
  const id = match?.[1] || match?.[2] || ''
  return id ? id.slice(-6) : null
}

function handleFromTitle(title: string): string | null {
  const at = title.match(/@([A-Za-z0-9_]{2,40})/)
  if (at?.[1] && at[1] !== '?') return at[1]

  const url = title.match(/(?:x|twitter)\.com\/([A-Za-z0-9_]{2,40})\/status\//i)
  if (url?.[1] && url[1].toLowerCase() !== 'i') return url[1]

  const slug = title.match(/-([A-Za-z0-9_]{2,40})-on-(?:xhttpsxcom|httpsxcom|twittercom|httpstwittercom)/i)
  if (slug?.[1]) return slug[1]

  return null
}

function xLinkTopicTitle(title: string): string {
  const short = statusShort(title)
  const handle = handleFromTitle(title)
  const fallback = handle ? `X @${handle}` : 'X link'
  return short ? `${fallback} - #${short}` : fallback
}

export function todoistTaskTitle(title: string): string {
  let clean = title.trim().replace(/\.md$/i, '')
  clean = clean.replace(TODOIST_TASK_SUFFIX_RE, '')
  if (clean.includes('-') && !/\s/.test(clean)) {
    clean = clean.replace(/-/g, ' ')
  }
  clean = clean.replace(/\s+/g, ' ').trim()
  if (clean && /^[a-z]/.test(clean)) {
    clean = clean.charAt(0).toUpperCase() + clean.slice(1)
  }
  return clean || title
}

export function topicDisplayTitle(topic: TopicTitleInput): string {
  const rawTitle = (topic.title || '').trim()
  if (!rawTitle) return '(untitled)'
  if (!X_TITLE_RE.test(rawTitle)) {
    if (topic.source_kind === 'todoist' || topic.source_kind === 'todoist_task') {
      return todoistTaskTitle(rawTitle)
    }
    return rawTitle
  }

  return xLinkTopicTitle(rawTitle)
}
